import {
  EXTERNAL_LINKS,
  PRIVATE_ROUTES,
  REDIRECT_TO_URL_PATH_REGEX,
  ROUTES,
} from './constants'

function redirectToAuthPage(path: string, redirectTo = '/') {
  if (
    window.location.pathname.includes(ROUTES.logout) ||
    window.location.pathname.includes(ROUTES.login)
  ) {
    return
  }

  const finalUrl = new URL(path, window.location.href)

  if (isValidRedirect(redirectTo)) {
    finalUrl.searchParams.append('redirectTo', redirectTo)
  }

  window.location.href = finalUrl.toString()
}

export function logout(redirectTo = '/') {
  return redirectToAuthPage(ROUTES.logout, redirectTo)
}

export function redirectToLogin(redirectTo = '/') {
  return redirectToAuthPage(ROUTES.login, redirectTo)
}

export function isPrivateRoute(route: string) {
  return PRIVATE_ROUTES.some((privateRoute: string | RegExp) => {
    if (privateRoute instanceof RegExp) {
      return privateRoute.exec(route)
    }

    return privateRoute === route
  })
}

export function isValidRedirect(path: string) {
  const isSafeExternalLink = Object.values(EXTERNAL_LINKS).includes(path)

  const isPath = REDIRECT_TO_URL_PATH_REGEX.test(path)
  const isValidRoute = ![
    ROUTES.login,
    ROUTES.authLogin,
    ROUTES.signup,
    ROUTES.accessDenied,
    ROUTES.notFound,
  ].includes(path)

  const isMydraDomain =
    path && /^https:\/\/(?:[\w-]+\.)*mydra\.io(?:\/.*)?$/.test(path)

  // allow localhost URLs for local development
  const isLocalhost =
    path && /^http:\/\/localhost(?::\d+)?(?:\/.*)?$/.test(path)

  return !!(
    path &&
    (isMydraDomain ||
      isLocalhost ||
      isSafeExternalLink ||
      (isPath && isValidRoute))
  )
}
